<template>
  <v-tabs
    class="mt-4"
    height="30px"
    slider-size="2"
    background-color="transparent"
    v-model="tab"
  >
    <v-tab
      v-for="type in tabType"
      :key="type.key"
      :class="[$globalStyle.tabColor, 'px-0', 'customerTab']"
      v-text="type.value"
    ></v-tab>
  </v-tabs>
</template>
<style scoped>
.customerTab {
  min-width: 50px !important;
  height: 30px !important;
}
</style>
<script>
export default {
  props: ["value"],
  data: () => ({
    tab: "0",
    tabType: [
      {
        key: "all",
        value: "全部"
      },
      {
        key: "cat",
        value: "貓咪"
      },
      {
        key: "dog",
        value: "狗狗"
      },
      {
        key: "other",
        value: "其他"
      }
    ]
  }),
  watch: {
    tab(val) {
      console.log("val:" + val);
      this.$emit("input", this.tabType[val].key);
    }
  },
  mounted() {
    let thisVm = this;
    this.tabType.forEach((element, index) => {
      if (element.key === thisVm.value) {
        thisVm.tab = index;
      }
    });
  }
};
</script>
